import React from "react";
import { ConfigSectionType } from "../../../shared/enums/rbacRoles";
import {
  canAccessAnyConfig,
  canAccessCommonConfig,
  canAccessSection,
} from "../../utils/configAccess";
import ErrorPage from "../errorPage/errorPage";

interface ProtectedConfigRouteProps {
  children: React.ReactNode;
  requiredSection?: ConfigSectionType;
  requireSuperAdmin?: boolean;
}

const ProtectedConfigRoute = ({
  children,
  requiredSection,
  requireSuperAdmin,
}: ProtectedConfigRouteProps) => {
  if (!canAccessAnyConfig()) return <ErrorPage />;
  if (requireSuperAdmin && !canAccessCommonConfig()) return <ErrorPage />;
  if (requiredSection && !canAccessSection(requiredSection))
    return <ErrorPage />;
  return <>{children}</>;
};

export default ProtectedConfigRoute;
